import Chart from 'chart.js/dist/chart';

const brokersChart = document.querySelectorAll(".i-broker-list-chart");
brokersChart.forEach(chart => {
  const brokerData = chart.getAttribute('data-chart-data').split(",");
  const brokerLabels = chart.getAttribute('data-chart-labels').split(",");
  const canvas = chart.querySelector(".i-broker-chart__canvas");

  const data = {
    labels: brokerLabels,
    datasets: [{
      data: brokerData,
      backgroundColor: [
        '#5CAAE6',
        '#6CD6B1',
        '#E5E05B',
        '#EBA661',
        '#EB619B'
      ],
      hoverBackgroundColor: [
        '#5CAAE6',
        '#6CD6B1',
        '#E5E05B',
        '#EBA661',
        '#EB619B'
      ],
      hoverOffset: 0,
      borderWidth: 1,
      hoverBorderColor: "rgba(255, 255, 255, 100)",
      cutout: 45,
    }],

  };
  const config = {
    type: 'doughnut',
    data: data,
    options: {
      plugins: {
        legend: {
          display: false
        }
      },
    }
  };

  new Chart(canvas, config);
});
